import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ConvertHelper } from '@barthauer/abc/core';
import { ResourceManagerService } from '@barthauer/abc/core/resources';
import { ResourceSet } from 'libs/abc/core/resources/src/lib/resource-set';
import { DataEntity } from '../../..';
import { MapService } from '../../services/map.service';

@Component({
    selector: 'abc-graphics-networktracing',
    templateUrl: './networktracing.component.html',
    styleUrls: ['./networktracing.component.scss'],
    standalone: false
})
export class NetworktracingComponent implements AfterViewInit, OnInit {
  @ViewChild('networkframe', { static: false }) networkframe: ElementRef;
  @Output() closeNetworkTracingDialog = new EventEmitter();
  URL: SafeResourceUrl;
  public res = ResourceSet.Empty;

  constructor(
    private mapService: MapService,
    private sanitizer: DomSanitizer,
    private resourceService: ResourceManagerService
  ) {
    if (window.addEventListener) {
      window.addEventListener('message', this.pbResultsFromNetworkTracing.bind(this), false);
    } else {
      (<any>window).attachEvent('onmessage', this.pbResultsFromNetworkTracing.bind(this));
    }
  }

  async ngOnInit() {
    this.res = await this.resourceService.getResourceSet('abc-graphics-adapters-open-layers');
  }

  ngAfterViewInit(): void {}

  init(url: string) {
    const optionAsParameters = '&HideObjectSelection=true&HideObjectInfo=true';
    url += optionAsParameters;
    this.URL = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  public pbResultsFromNetworkTracing(e: any) {
    try {
      const results = e.data;
      if (results) {
        if (results === -1) {
          this.closeNetworkTracingDialog.emit();
        } else {
          const resultObject = JSON.parse(results);

          if (resultObject?.TracedObjects)
          {
            const dataEntities: DataEntity[] = [];
            for(let ot of Object.keys(resultObject.TracedObjects)) {
              const ids = resultObject.TracedObjects[ot];
              if (ids) {
                for(const id of ids) {
                  dataEntities.push({ id: id, objectType: parseFloat(ot) });
                }
              }
            }
            this.mapService.navigateToObjects(dataEntities);
          }
        }
      } else this.mapService.sendMapShortMessage(this.res.get('Controls-NetworkTracing-NoDataError'));
    } catch (error) {
      console.log(error.message);
    }
  }

  setVisible(visible: boolean): void {
    if (this.networkframe && this.networkframe.nativeElement)
      this.networkframe.nativeElement.style.visibility = visible ? 'visible' : 'hidden';
  }
}
